import { useQuizContext } from "./QuizContext";

export function useDog(dogId: string) {
  const { state, dispatch } = useQuizContext();

  const form = state.dogForms[dogId];

  const update = (patch: any) =>
    dispatch({
      type: "UPDATE_DOG_FORM",
      dogId,
      payload: patch,
    });

  return {
    dogId,
    form,
    update,
  };
}
